import React from 'react';
import {CdaWebModalRadioButton} from './cdawebmodalradiobutton.js';


/**
 * Modal's 'More Options' section that deals with setting parameters to request made to CDAWeb server.
 * @param prop.checkedOptions array of number that keeps track of checked items.
 * @param props.handleOptionsChange Function that deals with changes to checkedOptions.
 * @param props.currentRadioBtn string that indicates which component is currently selected.
 * @param porps.setRadioButton Function that deals with changes to currentRadioBtn.
 * @return JSX
 */
export function CdaWebModalMoreOptionsContainer(props) {
    const {allOptions, checkedOptions, handleOptionsChange, currentRadioBtn, setRadioButton}= props;

    return ( allOptions &&
      <div>
        <CdaWebModalRadioButton
          currentOption={currentRadioBtn}
          handleRadioButtonChange = {setRadioButton} />

        {allOptions.map((el, index) => (
          <div key={index} className='cdaWebModalGroupContainer'>
            <div key={index + 1000} className="cdaWebModalMoreOptionsTitle">{el.group} Options</div>
            <div className = 'cdaWebModalOptionGroupContainer'>
              {el.options.map((option, index) => (
                <label key={index + 20000}>
                  <input
                    key={index + 30000}
                    type="checkbox"
                    checked={checkedOptions.filter((el)=>{return el.id === option.label}).length > 0}
                    onChange={(e) => handleOptionsChange(option, e.target.checked)} />
                    &emsp;{option.label}
                </label>
               ))}
            </div>
          </div>
        ))}
      </div>
    )
}
